import React from 'react';
import {
    ElementType,
    IComponentConfigInfo,
    ICustomAdvancedTableColumns,
    IContentInfo,
    IColumnsExpandInfo,
} from '../interface';
import { Button, Iconfont, Switch } from '@umu/umu-design';
import { ListBlankPC } from 'businessCommon/src/components';
import { UserLabel } from '../components/elementComponents/userLabel';
import isObject from 'lodash/isObject';
import { ProgressElement } from '../components/elementComponents/progressElement';
import { StatusLabel, StatusLabelList } from '../components/elementComponents/statusLabel';
import { UserPointDetail } from '../components/elementComponents/userPointDetail';
import { CustomColumnTitle, RenderConfig } from '../components';
import { lang } from '@umu/ukit-lang';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import { MenuDrop } from '../../menuDrawer/dropMenu';

const defaultEmptyText = <ListBlankPC className="list-blank-img-512-absolute" desc={lang('暂无数据')} type={7} />;

const getEleRenderType = (type: ElementType, { value, info }: any, config: Record<string, any>) => {
    switch (type) {
        case ElementType.PROGRESS:
            return <ProgressElement value={value} config={config} />;
        case ElementType.USER_LABEL:
            return <UserLabel info={info} config={config} />;
        case ElementType.STATUS_LABEL:
            return <StatusLabel info={info} config={config} value={value} />;
        case ElementType.STATUS_LABEL_LIST:
            return <StatusLabelList info={info} config={config} value={value} />;
        case ElementType.USER_POINT_DETAIL:
            return <UserPointDetail info={info} config={config as any} />;
        case ElementType.BUTTON:
            return (
                <Button {...config} onClick={() => config.onClick({ value, info })}>
                    {config.label}
                </Button>
            );
        case ElementType.LABEL_ICON:
            return (
                <div className="icon-info">
                    {!config?.hideValue ? <div className="icon-info-label">{value}</div> : ''}
                    {!config.hide && (
                        <Iconfont
                            type={config?.iconType || ''}
                            className="icon-element"
                            onClick={(e) => config?.onClick?.({ value, info, event: e })}
                        />
                    )}
                </div>
            );
        case ElementType.BUTTON_LIST:
            return (
                <div className={`button-list ${config?.className || ''}`}>
                    {(config?.list || []).map((item: any, index: number) => {
                        const {
                            isMenu = false,
                            menuList = [],
                            getMenuConfig,
                            getButtonConfig,
                            onClick,
                            ...rest
                        } = item;
                        const tmpMenuList = getMenuConfig ? getMenuConfig({ value, info }) : menuList;
                        const tmpButtonConfig = getButtonConfig ? getButtonConfig({ value, info }) : rest;
                        return isMenu ? (
                            <MenuDrop
                                className={rest?.className || ''}
                                onChange={(key) => onClick({ value, info, key })}
                                list={tmpMenuList}
                            >
                                <Button isOnlyChildren type="text" {...tmpButtonConfig}>
                                    {item?.label || lang('更多')}
                                </Button>
                            </MenuDrop>
                        ) : (
                            <Button
                                key={index}
                                {...tmpButtonConfig}
                                onClick={(e) => onClick({ value, info, event: e })}
                            >
                                {item.label}
                            </Button>
                        );
                    })}
                </div>
            );
        case ElementType.SWITCH:
            return (
                <Switch
                    defaultChecked={config.getCheck(info)}
                    {...config.switchProps}
                    onChange={(val) => config.onChange(val, info)}
                />
            );
        default:
            const showLabel = config?.getShowLabel ? config.getShowLabel({ value, info }) : config?.title || '';
            return (
                <div
                    className={config.className}
                    {...config?.attribute}
                    dangerouslySetInnerHTML={{
                        __html: showLabel,
                    }}
                />
            );
    }
};
const getContentElement = (data: IContentInfo | IContentInfo[], params: any) => {
    if (!data) {
        return '';
    }
    if (isArray(data)) {
        return (
            <div className="content-element-list">
                {data.map((item, index) => {
                    return (
                        <div key={index} className="content-element-list-item">
                            {getContentElement(item, params)}
                        </div>
                    );
                })}
            </div>
        );
    }
    if (isObject(data)) {
        return getEleRenderType(
            (data as IComponentConfigInfo)?.type || ElementType.__INIT__,
            params,
            (data as IComponentConfigInfo)?.config || {},
        );
    }
    return data;
};
const getColumns = <T extends object>(list: ICustomAdvancedTableColumns<T>[], expandInfo: IColumnsExpandInfo) => {
    return list.map((item) => {
        const {
            title,
            isCustomTitle = false,
            titlePrefix,
            titleIcon,
            titleSuffix,
            renderConfig,
            tooltipConfig,
            ...rest
        } = item;
        const isShowCheckbox = item?.checkbox;
        const config: any = !!renderConfig
            ? {
                  render: (value: keyof T | string, info: T, index: number) => {
                      return (
                          <RenderConfig
                              isCheckbox={isShowCheckbox}
                              expandInfo={expandInfo}
                              value={value}
                              info={info}
                              index={index}
                              configInfo={renderConfig}
                          />
                      );
                  },
              }
            : {};
        return {
            title:
                isString(title) && !isCustomTitle ? (
                    title
                ) : (
                    <CustomColumnTitle {...item} tooltipConfig={tooltipConfig} expandInfo={expandInfo} />
                ),
            dataIndex: item.key,
            ...rest,
            ...config,
        };
    });
};

export { defaultEmptyText, getContentElement, getEleRenderType, getColumns };
